import notify from '@/api/notification'
import doctorService from '@/api/doctor'
import {
  DOCTOR_UPDATE_LIST,
  DOCTOR_STATUS
} from '../types'

const state = {
  doctors: [],
  doctorStatus: 'STATUS_INITIAL'
}

const mutations = {
  [DOCTOR_UPDATE_LIST] (state, data) {
    state.doctors = data
  },
  [DOCTOR_STATUS] (state, status) {
    state.doctorStatus = status
  }
}

const getters = {
  doctorList: state => {
    return state.doctors
  },
  doctorIsLoading: state => {
    return state.doctorStatus === 'LOADING'
  }
}

const actions = {
  getDoctors: ({commit}) => {
    commit(DOCTOR_STATUS, 'LOADING')
    return doctorService
      .getDoctors()
      .then((res) => {
        if (res.status === 200) {
          let items = res.data
          items = items.map((item) => {
            item.crm = item.crm.toString()
            return item
          })
          commit(DOCTOR_UPDATE_LIST, items)
          commit(DOCTOR_STATUS, 'STATUS_INITIAL')
        }
      })
      .catch(() => {
        commit(DOCTOR_STATUS, 'STATUS_INITIAL')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao carregar lista de médicos.'
        })
      })
  },
  doctorDelete: ({commit, state}, item) => {
    commit(DOCTOR_STATUS, 'LOADING')
    return doctorService
      .deleteDoctor(item.id_doctor)
      .then(() => {
        let items = state.doctors
        items = items.filter((obj) => {
          return obj.id_doctor !== item.id_doctor
        })
        commit(DOCTOR_UPDATE_LIST, items)
        commit(DOCTOR_STATUS, 'STATUS_INITIAL')
        notify({
          style: 'success',
          message: 'Médico removido com sucesso!'
        })
      })
      .catch(() => {
        commit(DOCTOR_STATUS, 'STATUS_INITIAL')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao desvincular médico.'
        })
      })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
